import { render, staticRenderFns } from "./wecomLogin.vue?vue&type=template&id=7996b3a4&scoped=true&"
import script from "./wecomLogin.vue?vue&type=script&lang=js&"
export * from "./wecomLogin.vue?vue&type=script&lang=js&"
import style0 from "./wecomLogin.vue?vue&type=style&index=0&id=7996b3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996b3a4",
  null
  
)

export default component.exports